module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABDUlEQVRIie2VMQ7CMAxFH0iwACMjF6ADEgucggtwCU4CokfgDExwDJhYu3YChg6IMsSWqtA2CdCNL1mOGts/be0f+CMQQzHFCEiB3LI7cAY2QORbvAXsxVqF5wvgWUKi9gBioOsiWBWSVo7YHjADtkAmOcc6kmkhMJf11HUiwQRIJC8uCxgAF95f/SJ7viQZ5nON7c1dSXG1nScBcvocWNcFaeFPMJPcU1MEfcm9NkVQmt/+opgXbIKb+H5TBIn4t1b7FcFB/DKgRrHNFZVtHmGGJcMMjw+CB1UHJgkgCZKaDka4NDAG5rh/fIhY0pXCD6pl5ImRckWV3NciwmjLCdPCNkmKuZQU9oX1hxsv9ntsmYmYPLAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/refresh.png
// module id = pckw
// module chunks = 1